import { FES_API } from "@apis/common";
import { store } from "@services/redux";

export const getQuestionnaireUrl = () => {
  const id = store.getState().transaction?.data.id;
  return FES_API.get(`customer-happiness-index/${id}/url`).then((response) => {
    return response.data;
  });
};
